<template>
  <v-container
    id="locations"
    fluid
    tag="section"
  >
    <base-v-component
      heading="Locations"
      link="locations/list"
    />

    <base-material-card
      icon="mdi-map-marker"
      title="Locations"
      class="px-5 py-3"
    >
      <v-simple-table>
       <thead>
  <tr>
                        <th>Name</th>
                        <th>Description</th>


        <th>Geo</th>
                        <th>Image</th>
                        <th>Actions</th>
                    </tr>        </thead>

        <tbody>
  <tr v-for="location in Locations" :key="location.key">
                        <td>{{ location.name }}</td>
                        <td>{{ location.description }}</td>
                          <td>{{ location.geo }}</td>
                        <td><img style="width: 300px" :src="location.image"></td>
                        <td>
                            <router-link :to="{name: 'edit', params: { id: location.key }}" class="btn btn-primary">Edit
                            </router-link>
                            <button @click.prevent="deleteLocation(location.key)" class="btn btn-danger">Delete</button>
                        </td>
                    </tr>        </tbody>

      </v-simple-table>
    </base-material-card>

</template>
<script>
    import { db } from '../../../firebaseDb';
    
    export default {
        data() {
            return {
                Locations: []
            }
        },
        created() {
            db.collection('locations').onSnapshot((snapshotChange) => {
                this.Locations = [];
                snapshotChange.forEach((doc) => {
                    this.Locations.push({
                        key: doc.id,
                        name: doc.data().name,
                         geo: doc.data().geo,
                        description: doc.data().description,
                        image: doc.data().img
                    })
                });
            })
        },
        methods: {
            deleteLocation(id){
              if (window.confirm("Do you really want to delete?")) {
                db.collection("locations").doc(id).delete().then(() => {
                    console.log("Document deleted!");
                })
                .catch((error) => {
                    console.error(error);
                })
              }
            }
        }
    }
</script>


